import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { DocumentsServe, TabSize } from 'src/app/utils/constants';
import { PageTab } from 'src/app/utils/enums';
import { PublicCardData } from 'src/app/utils/models';

@Component({
  selector: 'shared-center-card',
  templateUrl: './center-card.component.html',
  styleUrls: ['./center-card.component.scss'],
})
export class CenterCardComponent implements OnInit, OnChanges {
  @Input() currentScroll: number;
  @Input() currentTab: number;
  @Input() publicCardData: PublicCardData;
  @Output() currentTabChange: EventEmitter<number>;
  @Output() statusScroll: EventEmitter<number>;
  cache: string;
  coverImage: string;
  logoImage: string;

  constructor() {
    this.currentScroll = 0;
    this.currentTab = PageTab.PRESENTATION;
    this.publicCardData = new PublicCardData();
    this.statusScroll = new EventEmitter<number>();
    this.currentTabChange = new EventEmitter<number>();
    this.cache = '?nocache=' + Math.random();
    this.coverImage = '';
    this.logoImage = '';
  }

  ngOnInit(): void {
    // console.log(this.publicCardData);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if ('publicCardData' in changes) {
      if (this.publicCardData.urlBanner !== '') {
        this.coverImage =
          DocumentsServe.COVERPHOTOS +
          this.publicCardData.idTarjeta +
          '/' +
          this.publicCardData.urlBanner +
          this.cache;
      }
      this.logoImage =
        DocumentsServe.COVERPHOTOS +
        this.publicCardData.idTarjeta +
        '/' +
        this.publicCardData.urlLogotipo +
        this.cache;
    }
  }

  goToAboutMe(): void {
    this.statusScroll.emit(0);
    this.currentTab = PageTab.ABOUTME;
    this.currentTabChange.emit(PageTab.ABOUTME);
  }

  goToService(): void {
    const position = (window.innerWidth * 100 * 2) / 100;

    this.statusScroll.emit(position);
    this.currentTab = PageTab.SERVICES;
    this.currentTabChange.emit(PageTab.SERVICES);
  }

  goToCenter(): void {
    const position = (window.innerWidth * TabSize.SIZE) / 100;
    this.statusScroll.emit(position);
    this.currentTab = PageTab.PRESENTATION;
    this.currentTabChange.emit(PageTab.PRESENTATION);
  }
}
